// src/pages/ApplicationChampionshipSeason/shared/steps/Step1Info/GroupsCountField.tsx
import { FunctionComponent } from 'react';
import { Box } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { NumericalInputField } from '@/components/NumericalInputField/NumericalInputField';
import { SeasonFormData } from '../../schemas';
import { MAX_GROUPS, MIN_GROUPS } from '../../constants';

const PREFIX = 'pages.application_season.components.season_step1.fields.groups_count';

type GroupsCountFieldProps = {
  /** Quando true, desabilita o input (mudar nº de grupos é destrutivo). */
  isLocked?: boolean;
};

export const GroupsCountField: FunctionComponent<GroupsCountFieldProps> = ({
  isLocked = false,
}) => {
  const { t } = useTranslation();
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<SeasonFormData>();

  const value = watch('groups_count') ?? MIN_GROUPS;

  return (
    <Box maxW={{ base: '100%', md: '240px' }}>
      <NumericalInputField
        label={t(`${PREFIX}.label`)}
        min={MIN_GROUPS}
        max={MAX_GROUPS}
        value={value}
        isDisabled={isLocked}
        onChange={(_, valueAsNumber) =>
          setValue(
            'groups_count',
            Number.isNaN(valueAsNumber) ? MIN_GROUPS : valueAsNumber,
            { shouldDirty: true, shouldValidate: true },
          )
        }
        rootProps={{
          isInvalid: !!errors.groups_count,
          errorMessage: errors.groups_count?.message,
        }}
      />
    </Box>
  );
};
